import axios from 'axios'
import { ApiConfig } from '../../../../config/api'
import { Filter } from '../../../ASN20'

export const getPositions = (
  filters: Filter[],
  page: number,
  pageSize: number
) => {
  const url = new URL(`${ApiConfig.PositionApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())
  url.searchParams.set('exactCoincidence', true.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }
  console.log(url.toString())
  return axios.get(url.toString())
}

export const getSkus = (filters: Filter[], page: number, pageSize: number) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }
  return axios.get(url.toString())
}

export const getStock = (filters: Filter[], page: number, pageSize: number) => {
  const url = new URL(`${ApiConfig.StockApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }
  return axios.get(url.toString())
}
